/**
 * ToDo API
 * An ASP.NET Core Web API for managing ToDo items
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddressDataModel { 
    addressId?: string | null;
    country?: string | null;
    administrativeArea?: string | null;
    locality?: string | null;
    dependentLocality?: string | null;
    postalCode?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressLine3?: string | null;
    associatedIds?: Array<string>;
    longitude?: number;
    latitude?: number;
}

